export default __webpack_public_path__ + "4d8b8dfe68a90fca550ec1c830889385.png";